import { createSelector } from "reselect";
import { INITIAL_STATE } from "./reducers";

const selectGlobalDomain = (state) => state.global || INITIAL_STATE;
const makeSelectLoading = () => createSelector(selectGlobalDomain, (globalState) => globalState.loading);
const makeSelectRefresh = () => createSelector(selectGlobalDomain, (globalState) => globalState.refresh);

const makeSelectError = () => createSelector(selectGlobalDomain, (globalState) => globalState.error);
const makeSelectErrorMessage = () => createSelector(selectGlobalDomain, (globalState) => globalState.errorMessage);
const makeSelectUserName = () => createSelector(selectGlobalDomain, (globalState) => globalState.username);
const makeSelectAccessToken = () => createSelector(selectGlobalDomain, (globalState) => globalState.token);
const makeSelectGlobal = () => createSelector(selectGlobalDomain, (globalState) => globalState);
const makeSelectUserDetails = () => createSelector(selectGlobalDomain, (globalState) => globalState.userDetails);

export default makeSelectGlobal;
export {
  makeSelectGlobal,
  selectGlobalDomain,
  makeSelectError,
  makeSelectLoading,
  makeSelectRefresh,
  // makeSelectSideBar,
  // makeSelectDeviceDimension,
  makeSelectUserName,
  makeSelectErrorMessage,
  makeSelectAccessToken,
  makeSelectUserDetails
};
